module.exports = __webpack_public_path__ + "assets/8f4e55dc1ddac68bdefe3adc9682fd43.png";